import { Component, inject, Input, OnInit, Signal } from '@angular/core';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertService } from '@app/core/services/alert.service';
import { Alert } from '@shared/interfaces/alert/alert';
import { AlertAreas } from '@shared/components/alert-service-wrapper/alert-areas';

/**
 * @internal
 * Component that wraps alert display functionality for a specified alert area.
 * It retrieves and displays alerts for the given area using the AlertService.
 */
@Component({
  selector: 'app-alert-service-wrapper',
  imports: [
    AlertComponent,
    TranslatePipe
],
  templateUrl: './alert-service-wrapper.component.html',
  styleUrl: './alert-service-wrapper.component.css'
})
export class AlertServiceWrapperComponent implements OnInit {
  /**
   * The area for which alerts should be displayed.
   * Defaults to 'global'.
   */
  @Input() public area: AlertAreas = 'global';

  /** Alerts **/
  protected readonly alertService: AlertService = inject(AlertService);
  protected alerts!: Signal<Alert[]>;

  /**
   * Initializes the component by fetching alerts for the specified area.
   */
  public ngOnInit(): void {
    this.alerts = this.alertService.getAlertsByLocation(this.area);
  }


}
